export default __webpack_public_path__ + "static/media/arrows-horizontal.2ec8355f.svg";